import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { authActions } from '../../actions/auth';
import { UserIcon } from './icons';

export default function Topbar({ greeting, title, name = 'User' }) {
  const navigate = useNavigate();
  const dropRef = useRef(null);
  const [dropOpen, setDropOpen] = useState(false);

  const initials = name.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2) || 'U';

  useEffect(() => {
    if (!dropOpen) return;
    const handler = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setDropOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [dropOpen]);

  const handleLogout = () => {
    setDropOpen(false);
    authActions.performLogout();
    navigate('/login');
  };

  return (
    <div className="row app-topbar" style={{
      height: 64, flex: '0 0 64px', padding: '0 24px',
      borderBottom: '1px solid var(--border)',
      justifyContent: 'space-between', gap: 24,
      background: 'rgba(255,255,255,.01)',
    }}>
      <div style={{ minWidth: 0, flexShrink: 0 }}>
        {greeting && <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.02em' }}>{greeting}</div>}
        {title && <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.02em' }}>{title}</div>}
      </div>

      <div style={{ flex: 1 }} />

      <div className="row" style={{ gap: 10, flexShrink: 0 }}>
        {/* Avatar with dropdown */}
        <div ref={dropRef} style={{ position: 'relative' }}>
          <button onClick={() => setDropOpen(o => !o)} style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg, #FF7E67, #FF4D8D)', display: 'grid', placeItems: 'center', fontSize: 13, fontWeight: 700, border: 'none', cursor: 'pointer', color: '#fff' }}>
            {initials}
          </button>
          {dropOpen && (
            <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, width: 180, background: 'rgba(12,12,20,.98)', border: '1px solid rgba(255,255,255,.1)', borderRadius: 10, overflow: 'hidden', boxShadow: '0 16px 40px -8px rgba(0,0,0,.8)', zIndex: 9999 }}>
              <div style={{ padding: '10px 14px', borderBottom: '1px solid rgba(255,255,255,.06)' }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{name}</div>
              </div>
              <button onClick={() => { setDropOpen(false); navigate('/account'); }} style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px', background: 'none', border: 'none', color: '#fff', fontSize: 13, cursor: 'pointer', textAlign: 'left' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,.06)'}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
              >
                <UserIcon s={13} /> Account settings
              </button>
              <div style={{ height: 1, background: 'rgba(255,255,255,.06)' }} />
              <button onClick={handleLogout} style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '10px 14px', background: 'none', border: 'none', color: '#F5576C', fontSize: 13, cursor: 'pointer', textAlign: 'left' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(245,87,108,.06)'}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
              >
                <span>↪</span> Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
